import EconomicModelFormHandler from '../utils/EconomicModelFormHandler';

export default class BackofficeOrdersShow {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    $(".order-edit").on('click', event => {
      const orderItemId = $(event.currentTarget).data('order-item');
      const OrderId = $(event.currentTarget).data('order');
      this.launchOrderEditModal(OrderId, orderItemId);
    });

    $("#order-form-submit").on('click', event => {
      this.submitOrderForm();
    });

    // Initialize study pricing modal
    $('#study-pricing-modal').on('show.bs.modal', (event) => {
      this.initializeStudyPricingModal(event);
    });

    // Apply original prices
    $("#apply-original-prices-btn").on('click', event => {
      this.applyOriginalPrices();
    });

    // Apply study prices
    $("#apply-study-prices-modal-btn").on('click', event => {
      this.applyStudyRequestPrices();
    });
  }

  onDataChanged(data) {
  }

  setupStudyRequestConfirmationModal() {
    EconomicModelFormHandler.setup();
  }

  onDestroy() {
  }

  launchOrderEditModal(orderId, orderItemId) {
    let url = "/orders/" + orderId + "/ajax_order_item_form/" + orderItemId;

    $.ajax({
      url: url,
      type: "GET",
      success: (data) => {
        $("#order-edit-modal-body").html(data);
        $("#order-edit-modal").modal("show");
        // Setup economic model form handler if needed
        EconomicModelFormHandler.setup();
      }
    });
  }

  submitOrderForm() {
    console.log("submitOrderForm");
    let form = $("#order-form");
    form.trigger('submit.rails'); 
  }

  initializeStudyPricingModal(event) {
    const button = $(event.relatedTarget);
    const orderId = button.data('order-id');
    const currentFas = Number.parseFloat(button.data('current-fas'));
    const currentSubscription = Number.parseFloat(button.data('current-subscription'));
    const originalFas = Number.parseFloat(button.data('original-fas'));
    const originalSubscription = Number.parseFloat(button.data('original-subscription'));
    const studyFas = Number.parseFloat(button.data('study-fas'));
    const studySubscription = Number.parseFloat(button.data('study-subscription'));
    const studyOneTimeRevenue = Number.parseFloat(button.data('study-one-time-revenue'));
    const studyFar = Number.parseFloat(button.data('study-far'));
    const studyIru = Number.parseFloat(button.data('study-iru'));
    const studyRecurrentPrice = Number.parseFloat(button.data('study-recurrent-price'));
    const pricesApplied = button.data('prices-applied');
    const applyStudyUrl = button.data('apply-study-url');
    const revertUrl = button.data('revert-url');

    // Store data in modal
    const modal = $('#study-pricing-modal');
    modal.data('order-id', orderId);
    modal.data('apply-study-url', applyStudyUrl);
    modal.data('revert-url', revertUrl);

    // Update current prices
    $('#modal-current-fas').text(I18n.toCurrency(currentFas));
    $('#modal-current-subscription').text(I18n.toCurrency(currentSubscription));

    // Update original prices
    $('#modal-original-fas').text(I18n.toCurrency(originalFas));
    $('#modal-original-subscription').text(I18n.toCurrency(originalSubscription));

    // Update study prices
    $('#modal-study-fas').text(studyFas ? I18n.toCurrency(studyFas) : '--');
    $('#modal-study-subscription').text(studySubscription ? I18n.toCurrency(studySubscription) : '--');
    $('#modal-study-one-time-revenue').text(studyOneTimeRevenue ? I18n.toCurrency(studyOneTimeRevenue) : '--');
    $('#modal-study-far').text(studyFar ? I18n.toCurrency(studyFar) : '--');
    $('#modal-study-iru').text(studyIru ? I18n.toCurrency(studyIru) : '--');
    $('#modal-study-recurrent-price').text(studyRecurrentPrice ? I18n.toCurrency(studyRecurrentPrice) : '--');
    $('#modal-study-recurrent-label').text(button.data('study-recurrent-label'));

    // Highlight current pricing source
    const usingOriginal = Math.abs(currentFas - originalFas) < 0.01 && Math.abs(currentSubscription - originalSubscription) < 0.01;
    const usingStudy = studyFas && studySubscription && Math.abs(currentFas - studyFas) < 0.01 && Math.abs(currentSubscription - studySubscription) < 0.01;

    $('.pricing-card').removeClass('border-success');
    if (usingOriginal) {
      $('#original-pricing-card').addClass('border-success');
    } else if (usingStudy) {
      $('#study-pricing-card').addClass('border-success');
    }
  }

  applyOriginalPrices() {
    const modal = $('#study-pricing-modal');
    const revertUrl = modal.data('revert-url');
    
    if (!revertUrl) {
      if (application && application.errorNotification) {
        application.errorNotification("Impossible de trouver l'URL de restauration");
      }
      return;
    }

    modal.modal('hide');

    $.ajax({
      url: revertUrl,
      type: "PUT",
      dataType: "json",
      success: (response) => {
        if (response.success) {
          if (application && application.successNotification) {
            application.successNotification(response.message || "Prix produit appliqués avec succès");
          }
          location.reload();
        }
      },
      error: (xhr) => {
        let errorMessage = "Erreur lors de l'application des prix produit";
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = xhr.responseJSON.error;
        }
        if (application && application.errorNotification) {
          application.errorNotification(errorMessage);
        }
      }
    });
  }

  applyStudyRequestPrices() {
    const modal = $('#study-pricing-modal');
    const applyStudyUrl = modal.data('apply-study-url');
    
    if (!applyStudyUrl) {
      if (application && application.errorNotification) {
        application.errorNotification("Impossible de trouver l'URL d'application");
      }
      return;
    }

    modal.modal('hide');

    $.ajax({
      url: applyStudyUrl,
      type: "PUT",
      dataType: "json",
      success: (response) => {
        if (response.success) {
          if (application && application.successNotification) {
            application.successNotification(response.message || "Prix de l'étude appliqués avec succès");
          }
          location.reload();
        }
      },
      error: (xhr) => {
        let errorMessage = "Erreur lors de l'application des prix de l'étude";
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = xhr.responseJSON.error;
        }
        if (application && application.errorNotification) {
          application.errorNotification(errorMessage);
        }
      }
    });
  }
}